import { Injectable } from '@angular/core';
import { api } from '../../app/URL/api-url';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  loadAuthorizeNetScript(): void {
    const scriptId = 'accept-js';

    if (document.getElementById(scriptId)) {
      return; // already loaded
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = api.acceptJsUrl;
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    document.body.appendChild(script);
  }
}
